import { httpsCallable } from "firebase/functions";
import { functions } from "../Config/firebase";

export async function gerarSequencial({ chave, escopo = "", formato = {}, valorMinimo = 0 }) {
  const gerarSequencialFn = httpsCallable(functions, "gerarSequencial");
  const resultado = await gerarSequencialFn({ chave, escopo, formato, valorMinimo });
  return resultado.data;
}

export function obterMaiorSequencial(lista = [], regex = /(\d+)/) {
  return lista.reduce((maior, item) => {
    const match = String(item?.codigo || "").match(regex);
    const numero = Number(match?.[1] || match?.[0] || 0);
    return Number.isFinite(numero) && numero > maior ? numero : maior;
  }, 0);
}
